import { render, staticRenderFns } from "./500.vue?vue&type=template&id=cb98266e&scoped=true"
var script = {}
import style0 from "./500.vue?vue&type=style&index=0&id=cb98266e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb98266e",
  null
  
)

export default component.exports